import { IAccountCrudModalLang, ACCOUNT_CRUD_MODAL_LANG_KEY } from './interface.IAccountCrudModalLang'
import { IAccountPageLang, ACCOUNT_PAGE_LANG_KEY } from './interface.IAccountPageLang'
import { IAccountListTableLang, ACCOUNT_LIST_TABLE_LANG_KEY } from './interface.IAccountListTableLang'

export * from './interface.IAccountCrudModalLang'
export * from './interface.IAccountPageLang'
export * from './interface.IAccountListTableLang'

export type IAccountAllLang =
	& IAccountPageLang
	& IAccountCrudModalLang
	& IAccountListTableLang

export const ACCOUNT_ALL_LANG_KEY: IAccountAllLang = {
	...ACCOUNT_CRUD_MODAL_LANG_KEY,
	...ACCOUNT_LIST_TABLE_LANG_KEY,
	...ACCOUNT_PAGE_LANG_KEY
}